import {
  params, shape as shapeType, number as numberType, bool as boolType, arrayOf as arrayOfType, extend
} from '@thd-nucleus/data-sources';
import { ListTile } from '@thd-olt-component-react/list-tile';

const list = shapeType(ListTile.dataModel.list);

export const dataModel = extend({
  lists: params({ page: numberType(), pageSize: numberType() }).shape({
    pagination: shapeType({
      pageSize: numberType(),
      totalResults: numberType(),
      totalPages: numberType(),
      hasMore: boolType()
    }),
    results: arrayOfType(list)
  })
}, ListTile);